import { LockClosedIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import axios from 'axios';
import { SERVER_URL } from "../config";
import ChangePasswordModal from '../components/PasswordChange';

const LoginPage = ({ onLoginSuccess }) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);


  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };



  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    if (!email || !password) {
      setError("Please enter both email and password.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${SERVER_URL}/auth/login.php`, {
        email,
        password
      });

      if (response.data.status === "success") {
        const { user, employee } = response.data;

        // ✅ Store employee details in localStorage
        if (employee) {
          localStorage.setItem("employee", JSON.stringify(employee));
        }

        // (Optional) Store logged-in user as well
        if (user) {
          localStorage.setItem("user", JSON.stringify(user));
        }

        // Continue original login success flow
        onLoginSuccess(response.data);

      } else {
        setError(response.data.message || "Invalid credentials");
      }

    } catch (err) {
      console.error(err);
      setError("Network error or server not responding.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="w-full max-w-sm bg-teal-100 rounded-xl shadow-2xl p-8">

        <div className="flex flex-col items-center mb-8">
          <img
            src="/logo.jpeg"
            alt="Company Logo"
            className="w-28 h-auto mb-4 object-contain"
          />

          <h1 className="text-2xl font-extrabold text-sky-800 text-center">
            SAJ Info Pvt. Ltd.
          </h1>

          <p className="mt-2 text-sm text-gray-500 text-center">
            Enter your credentials to continue.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-1">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your registered email"
              className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm
                         focus:ring-indigo-500 focus:border-indigo-500 bg-teal-100"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-900 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm pr-10
                          focus:ring-indigo-500 focus:border-indigo-500 bg-teal-100"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-indigo-700"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <EyeSlashIcon className="h-5 w-5" />
                ) : (
                  <EyeIcon className="h-5 w-5" />
                )}
              </button>
            </div>

            <div className="text-right">
              <button
                type="button"
                onClick={() => setShowChangePassword(true)}
                className="text-sm text-indigo-600 hover:underline"
              >
                Forget Password?
              </button>
            </div>
          </div>

          {error && (
            <p className="text-sm font-medium text-red-600 text-center">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full flex justify-center items-center py-2 px-4 rounded-lg text-white font-medium shadow-md
              ${isLoading ? 'bg-cyan-300' : 'bg-cyan-400 hover:bg-cyan-500'}`}
          >
            {isLoading ? (
              <svg className="animate-spin h-5 w-5 text-white mr-2" viewBox="0 0 24 24"></svg>
            ) : (
              <LockClosedIcon className="h-5 w-5 mr-2" />
            )}
            Log In
          </button>

        </form>

      </div>
      <ChangePasswordModal
        isOpen={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </div>

  );


};

export default LoginPage;
